import { connect } from 'react-redux'
import { EventMenu, EventMenuItems } from '../components'

const mapStateToProps1 = (state) => {
  const { user } = state.authentication
  const { language } = state.user
  return ({
    user,
    language
  })
}

const mapDispatchToProps1 = (dispatch, ownProps) => {
  return ({
    handleClickSearch: () => {
    }
  })
}

const ContEventMenuItems = connect(
  mapStateToProps1,
  mapDispatchToProps1,
)(EventMenuItems)


const mapStateToProps2 = (state) => {
  const { user } = state.authentication
  const { width } = state.window
  const { language } = state.user
  return ({
    user,
    width,
    language,
  })
}

const mapDispatchToProps2 = (dispatch, ownProps) => {
  return ({
  })
}

const ContEventMenu = connect(
  mapStateToProps2,
  mapDispatchToProps2,
)(EventMenu)

export { ContEventMenuItems as EventMenuItems, ContEventMenu as EventMenu }



// WEBPACK FOOTER //
// ./src/Pages/Event/containers/EventMenu.js